import React, { useEffect, useRef, useState } from "react";
import { formatReportDate } from "../utils/reportDate";

const displayToIsoDate = (displayValue) => {
  const match = String(displayValue || "").match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!match) return "";

  const [, day, month, year] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (
    date.getFullYear() !== Number(year) ||
    date.getMonth() !== Number(month) - 1 ||
    date.getDate() !== Number(day)
  ) return "";

  return `${year}-${month}-${day}`;
};

const formatTypedDate = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
};

const FormattedDateInput = ({ id, name, value = "", onChange, className = "form-control", disabled = false, required = false }) => {
  const pickerRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(value ? formatReportDate(value, "") : "");

  useEffect(() => {
    setDisplayValue(value ? formatReportDate(value, "") : "");
  }, [value]);

  const emitValue = (nextValue) => {
    onChange?.({ target: { name, value: nextValue } });
  };

  const handleTextChange = (event) => {
    const nextDisplayValue = formatTypedDate(event.target.value);
    setDisplayValue(nextDisplayValue);

    if (!nextDisplayValue) emitValue("");
    if (nextDisplayValue.length === 10) {
      const isoDate = displayToIsoDate(nextDisplayValue);
      if (isoDate) emitValue(isoDate);
    }
  };

  const openPicker = () => {
    if (disabled) return;
    if (typeof pickerRef.current?.showPicker === "function") pickerRef.current.showPicker();
    else pickerRef.current?.click();
  };

  return (
    <div className="input-group">
      <input
        id={id}
        name={name}
        type="text"
        inputMode="numeric"
        className={className}
        placeholder="dd-mm-yyyy"
        value={displayValue}
        disabled={disabled}
        required={required}
        maxLength={10}
        onChange={handleTextChange}
        onBlur={() => setDisplayValue(value ? formatReportDate(value, "") : "")}
      />
      <button type="button" className="btn btn-outline-secondary" aria-label={`Choose ${name || "date"}`} disabled={disabled} onClick={openPicker}>
        <span aria-hidden="true">&#128197;</span>
      </button>
      <input
        ref={pickerRef}
        type="date"
        value={value || ""}
        disabled={disabled}
        tabIndex="-1"
        aria-hidden="true"
        style={{ position: "absolute", width: 1, height: 1, opacity: 0, pointerEvents: "none" }}
        onChange={(event) => emitValue(event.target.value)}
      />
    </div>
  );
};

export default FormattedDateInput;
